import React from "react";

function PlusIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="none"
            viewBox="0 0 50 50"
        >
            <path
                fill="#58616D"
                d="M25 0C11.194 0 0 11.146 0 24.894c0 13.749 11.194 24.894 25 24.894s25-11.146 25-24.894C50 11.146 38.806 0 25 0zm14.594 24.894a2.764 2.764 0 01-2.77 2.758H27.77v9.016A2.764 2.764 0 0125 39.426a2.764 2.764 0 01-2.77-2.758v-9.016h-9.054a2.764 2.764 0 01-2.77-2.758 2.764 2.764 0 012.77-2.758h9.054V13.12A2.764 2.764 0 0125 10.362c1.53 0 2.77 1.235 2.77 2.758v9.016h9.054c1.53 0 2.77 1.235 2.77 2.758z"
            ></path>
        </svg>
    );
}

export default PlusIcon;
